import { useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { uploadChatMedia } from "../../../helpers/apis";
import { sendChatMessage, updateChatListOrder } from "../../../slices/chat/thunk";

export const useFileUpload = (selectedChatId, currentChat) => {
  const dispatch = useDispatch();
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFilePreview, setSelectedFilePreview] = useState("");
  const fileInputRef = useRef(null);

  const pickFile = (accept) => {
    if (!fileInputRef.current) return;
    fileInputRef.current.accept = accept;
    fileInputRef.current.click();
  };

  const onLocalFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setSelectedFile(file);
      setSelectedFilePreview(URL.createObjectURL(file));
    }
    e.target.value = "";
  };

  const handleDrop = async (e) => {
    e.preventDefault();
    const file = e.dataTransfer?.files?.[0];
    if (file) {
      setSelectedFile(file);
      setSelectedFilePreview(URL.createObjectURL(file));
    }
  };

  // In useFileUpload.js - Update handleUploadFile function
  const handleUploadFile = async (file, captionText = "") => {
    const chatId = selectedChatId || currentChat?.chatRequestId || currentChat?._id;
    if (!chatId || !file) return;

    try {
      const form = new FormData();
      form.append("file", file);

      const uploadResult = await uploadChatMedia(chatId, form);

      const caption = (captionText || "").trim();
      if (caption) {
        await dispatch(sendChatMessage({
          chatId,
          content: caption,
        })).unwrap();
      }

      dispatch(updateChatListOrder(chatId));
      setSelectedFile(null);
      setSelectedFilePreview("");
    } catch (err) {
      console.error("Upload failed:", err);
    }
  };

  return {
    selectedFile,
    selectedFilePreview,
    setSelectedFile,
    setSelectedFilePreview,
    fileInputRef,
    pickFile,
    onLocalFileChange,
    handleDrop,
    handleUploadFile
  };
};

